import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { load, resetCompositionState } from '../../store/composition/composition';
import { translate } from '../../helpers/translate.js';
import { compositionTypes } from '../../store/composition/helpers.js';
import '@sdb-develop/learning-frontend';
import '../shared/sdb-player-dialog.js';

@customElement('sdb-composition-reset-button-admin')
class SdbCompositionResetButtonAdmin extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor targetId;

    @property({ type: String })
    accessor compositionId;

    @property({ type: String })
    accessor idString;

    @property({ type: String })
    accessor label;

    @property({ type: Boolean })
    accessor disabled = false;

    @state()
    accessor list;

    @state()
    accessor isLoading;

    get composition() {
        return this.list[this.idString];
    }

    get noProgress() {
        return !this.composition || !this.composition.progress || this.composition.progress === 'started';
    }

    get buttonLabel() {
        return this.label || translate('btnResetAdmin');
    }

    get dialogId() {
        return `sdb_composition_reset_admin_dialog_${this.idString}`;
    }

    stateChanged(state) {
        this.list = state.composition.list;
        this.isLoading = state.composition.status === 'loading' || !state.composition.list;
    }

    render() {
        if (this.isLoading || this.noProgress) {
            return html`
                <sdb-content-button
                    label=${this.buttonLabel}
                    disabled>
                </sdb-content-button>
            `;
        }

        return html`
            <sdb-content-button
                label=${this.buttonLabel}
                ?outlined=${!this.disabled}
                ?disabled=${this.disabled}
                @click=${(e) => { this.shadowRoot.getElementById(this.dialogId).open(); }}>
            </sdb-content-button>
            <sdb-player-dialog
                id=${this.dialogId}
                type="confirm"
                heading=${translate('dlgResetHeaderAdmin')}
                body=${translate('dlgResetBodyAdmin', { catalogName: this.composition?.title })}
                confirmCaption=${translate('btnResetAdmin')}
                @confirm=${(e) => { this._executeReset(e); }}>
            </sdb-player-dialog>
        `;
    }

    firstUpdated() {
        store.dispatch(load({
            compositionId: this.compositionId,
            idString: this.idString,
        }));
    }

    _executeReset(e) {
        store.dispatch(resetCompositionState({
            compositionId: this.compositionId,
            idString: this.idString,
        }));

        this.dispatchEvent(
            new CustomEvent('reset', {
                bubbles: true,
                composed: true,
                detail: {
                    isSingleItem: this.composition.compositionType === compositionTypes.COMPOSITIONTYPE_SINGLEITEM
                                  && this.composition.items.length > 0,
                    idString: this.idString,
                },
                target: e.target,
            })
        );
    }
}
